export default "__VITE_ASSET__DwPiiX3s__"